export const REQUEST_PLAN_SUBSCRIPTIONS = 'REQUEST_PLAN_SUBSCRIPTIONS';
export const PLAN_SUBSCRIPTIONS_REQUEST_FAILED =
  'PLAN_SUBSCRIPTIONS_REQUEST_FAILED';
export const RECEIVED_PLAN_SUBSCRIPTIONS = 'RECEIVED_PLAN_SUBSCRIPTIONS';

export const UPDATE_SUBSCRIPTIONS_QUOTA_USAGE =
  'UPDATE_SUBSCRIPTIONS_QUOTA_USAGE';
export const QUOTA_USAGE_REQUEST_FAILED = 'QUOTA_USAGE_REQUEST_FAILED';
